<template>
  <div class="remove__list">
    <span>
      {{ $t("list.messages.select_list_or_chat") }}
    </span>
  </div>
</template>

<script>
import { EventEmitter } from "../main";

export default {
  computed: {
    not_exist_text() {
      return this.$route.name == "RemoveChat"
        ? this.$t("chat.messages.not_exist")
        : this.$t("list.messages.not_exist");
    },
  },
  mounted() {
    setTimeout(() => {
      let data = {
        type: "no_list",
        data: {
          text: this.not_exist_text,
          cancel: this.$t("app.alert.close"),
          delete: "",
        },
        list: "",
      };
      EventEmitter.$emit("OpenPopup", data);
    }, 100);
  },
};
</script>
